export default __webpack_public_path__ + "static/media/GM_Cup_Mystic.9411a308.png";